import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { request } from "@/js/http/http_request";
import { getFullNameUser } from "@/js/user/user.js";
import confirmationComponent from "@/components/modal/ConfirmationDialog.vue";
import { allowedBrazilCreditCardTypes } from "@/js/lists.ts";
export default {
  name: "CreditCardComponent",
  data: function data() {
    return {
      card: null,
      selectedCard: null,
      errorMessage: null,
      savePaymentForLater: false
    };
  },
  components: {
    confirm: confirmationComponent
  },
  props: ["stripe", "value", "savedCards", "clientSecret", "wallet", "user", "order", "inboundDelivery"],
  mounted: function mounted() {
    this.buildStripeInput();
  },
  computed: {},
  created: function created() {
    this.selectedCard = this.value;
  },
  methods: {
    fullNameUser: function fullNameUser(user) {
      return getFullNameUser(user);
    },
    selectCard: function selectCard(creditCard) {
      var index = this.savedCards.indexOf(creditCard);
      creditCard = _objectSpread(_objectSpread({}, creditCard), {}, {
        selected: !creditCard.selected
      });
      this.savedCards.splice(index, 1, creditCard);
      this.savedCards.filter(function (_, i) {
        return i !== index;
      }).forEach(function (x) {
        return x.selected = false;
      });
      this.$emit("input", !creditCard.selected ? null : this.savedCards[index]);
    },
    saveCard: function saveCard() {
      var _this = this;
      return this.stripe.confirmCardSetup(this.clientSecret, {
        payment_method: {
          card: this.card,
          type: "card",
          billing_details: {
            name: getFullNameUser(this.user),
            address: {
              postal_code: this.user.billing_address.zip
            }
          }
        }
      }).then(function (result) {
        var setupIntent = result.setupIntent;
        if (result.error) {
          _this.errorMessage = result.error.message;
          throw result.error;
        } else if (setupIntent.status === "requires_payment_method") {
          throw "Confirmation failed. Attempt again with a different payment method.";
        } else if (setupIntent.status === "succeeded") {
          if (_this.savePaymentForLater) {
            var data = {
              payment_method_id: result.setupIntent.payment_method
            };
            if (_this.order) {
              data = _objectSpread(_objectSpread({}, data), {}, {
                orderId: _this.order.id_order
              });
            } else if (_this.inboundDelivery) {
              data = _objectSpread(_objectSpread({}, data), {}, {
                inboundDeliveryId: _this.inboundDelivery.id
              });
            }
            request("/v1/stripe/payment-method", "post", data, true, "api").then(function () {
              _this.$emit("card-saved");
            });
          }
          return setupIntent.payment_method;
        }
      });
    },
    deleteCard: function deleteCard() {
      var _this = this;
      this.$refs.confirm.open("Delete", "Are you sure you want to delete this credit card ?", {
        color: "red"
      }).then(function (confirm) {
        if (confirm) {
          request("/v1/stripe/payment-method/" + _this.selectedCard.payment_method_id, "delete", null, true, "api").then(function (response) {
            _this.$emit("card-deleted");
          });
        }
      });
    },
    buildStripeInput: function buildStripeInput() {
      if (this.stripe) {
        var elements = this.stripe.elements({
          locale: "en"
        });
        this.card = elements.create("card", {
          hidePostalCode: true,
          iconStyle: "solid",
          style: {
            base: {
              padding: "20rem",
              textAlign: "center",
              color: "#000",
              iconColor: "#000",
              fontWeight: 500,
              fontSize: "16px",
              fontSmoothing: "antialiased",
              ":-webkit-autofill": {
                color: "#000"
              },
              "::placeholder": {
                color: "#CFD7DF"
              }
            },
            invalid: {
              color: "#FFC7EE",
              ":focus": {
                color: "#000"
              }
            }
          }
        });
        this.card.mount("#container-card");
        var _this = this;
        this.card.on("ready", function () {
          _this.card.focus();
        });
        this.card.on("change", function (e) {
          _this.$emit("inputChange");

          // Check Brazil credit card restrictions
          if (_this.order && _this.order.currency === "BRL" && e.brand) {
            var allowedBrands = allowedBrazilCreditCardTypes.map(function (x) {
              return x.id.toLowerCase();
            });
            if (!allowedBrands.includes(e.brand)) {
              _this.errorMessage = "The entered card type (".concat(e.brand, ") is not allowed for payments in Brazil. Please use ").concat(allowedBrazilCreditCardTypes.map(function (x) {
                return x.name;
              }).join(" or "), ".");
              _this.$emit("input", -1);
              return;
            }
          }
          if (e.complete) {
            _this.$parent.$data.stripeErrorOccured = false;
            _this.$emit("input", 0);
          }
          if (e.error) {
            _this.$emit("input", -1);
            _this.errorMessage = e.error.message;
          } else {
            _this.errorMessage = null;
          }
        });
      }
    }
  },
  watch: {
    stripe: function stripe() {
      this.buildStripeInput();
    }
  }
};